"use strict";

const _ = require('lodash');

const MIXINS = {};
function mix(superclass, ...mixins) {
	var r = superclass;
	for (let m of mixins) {
		if (!_.isFunction(m)) {
			m = _.get(MIXINS, m);
		}
		r = m(r);
	}
	return r;
}
mix.MIXINS = MIXINS;

module.exports = mix;